<template>
  <div class="animated fadeIn disable-text-select" @keyup.enter="onFilter"
    style="overflow: auto;  padding-bottom: 6rem; padding-left: 4px; padding-right: 4px;">
    <div class="form-group row">
      <div class="w-100">
        <label style="font-size: medium; font-weight: 600;letter-spacing: 0.3px; color: #2e6e60; cursor: pointer"
          @click.prevent="showFilterAssociado === true ? showFilterAssociado = false : showFilterAssociado = true">
          <i v-if="showFilterAssociado" class="fas fa-caret-down"></i>
          <i v-else class="fas fa-caret-right"></i>
          Associado</label>
        <!-- <div style="display: block; position: relative;top: -15px; color: #787878"><small>Campanha em rede sociais</small> </div>-->
      </div>
    </div>
    <div v-if="showFilterAssociado">
      <div class="form-group row">
        <div class="w-100">
          <label> CPF/CNPJ:</label>
          <div class="input-group">
            <b-form-input type="text" :placeholder="'Digite o CPF ou CNPJ'" v-model="form.document.value"
              :state="form.document.state" autofocus />
          </div>
        </div>
      </div>
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Nome:</label>
          <div class="input-group">
            <b-form-input type="text" :placeholder="'Digite o nome'" v-model="form.nome.value" :state="form.nome.state" />
          </div>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="w-100">
        <label style="font-size: medium; font-weight: 600;letter-spacing: 0.3px; color: #2e6e60; cursor: pointer"
          @click.prevent="showFilterInstituicao === true ? showFilterInstituicao = false : showFilterInstituicao = true">
          <i v-if="showFilterInstituicao" class="fas fa-caret-down"></i>
          <i v-else class="fas fa-caret-right"></i>
          Instituição</label>
        <!-- <div style="display: block; position: relative;top: -15px; color: #787878"><small>Campanha em rede sociais</small></div>-->
      </div>
    </div>
    <div v-if="showFilterInstituicao">
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> PA:</label>
          <div class="input-group">
            <v-select v-model="numeroPA.value" :options="numeroPA.listOptions" class="w-100"
            label="text" placeholder="Selecione o PA">
              <template v-slot:no-options>Nenhum PA encontrado.</template>
            </v-select>
            <!-- <b-form-input type="text" :placeholder="'Digite o número do PA'" v-model="form.numeroPA.value"
              :state="form.numeroPA.state" /> -->
          </div>
        </div>
      </div>
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Regional:</label>
          <div class="input-group">
            <v-select v-model="nomeRegional.value" :options="nomeRegional.listOptions" class="w-100"
            label="text" placeholder="Selecione a regional">
              <template v-slot:no-options>Nenhuma Regional encontrado.</template>
            </v-select>
            <!-- <b-form-input type="text" :placeholder="'Digite o nome da Regional'" v-model="form.nomeRegional.value"
              :state="form.nomeRegional.state" /> -->
          </div>
        </div>
      </div>
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Gerente:</label>
          <div class="input-group w-100">
            <v-select multiple v-model="employee.selected" :options="employee.listOptions" class="w-100" label="text"
              placeholder="Selecione o gerente">
              <template v-slot:no-options>Nenhum Gerente encontrado.</template>
            </v-select>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="w-100">
        <label style="font-size: medium; font-weight: 600;letter-spacing: 0.3px; color: #2e6e60; cursor: pointer"
          @click.prevent="showFilterResponsavel === true ? showFilterResponsavel = false : showFilterResponsavel = true">
          <i v-if="showFilterResponsavel" class="fas fa-caret-down"></i>
          <i v-else class="fas fa-caret-right"></i>
          Responsáveis</label>
        <!-- <div style="display: block; position: relative;top: -15px; color: #787878"><small>Campanha em rede sociais</small> </div>-->
      </div>
    </div>
    <div v-if="showFilterResponsavel">
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Responsáveis:</label>
          <div class="input-group">
            <v-select multiple v-model="responsible.selected" :options="responsible.listOptions" class="w-100"
              label="text" placeholder="Selecione a pessoa responsável">
              <template v-slot:no-options>Nenhum Reponsável encontrado.</template>
            </v-select>
          </div>
        </div>
      </div>
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Grupos Responsáveis:</label>
          <div class="input-group">
            <v-select multiple v-model="groupResponsible.selected" :options="groupResponsible.listOptions" class="w-100"
              label="text" placeholder="Selecione o grupo responsável">
              <template v-slot:no-options>Nenhum grupo encontrado.</template>
            </v-select>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group row">
      <div class="w-100">
        <label style="font-size: medium; font-weight: 600;letter-spacing: 0.3px; color: #2e6e60; cursor: pointer"
          @click.prevent="showFilterCobranca === true ? showFilterCobranca = false : showFilterCobranca = true">
          <i v-if="showFilterCobranca" class="fas fa-caret-down"></i>
          <i v-else class="fas fa-caret-right"></i>
          Cobrança</label>
        <!-- <div style="display: block; position: relative;top: -15px; color: #787878"><small>Campanha em rede sociais</small></div> -->
      </div>
    </div>
    <div v-if="showFilterCobranca">
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Produtos:</label>
          <div class="input-group">
            <v-select multiple v-model="product.selected" :options="product.listOptions" placeholder="Selecione o produto"
              class="w-100" label="text">
              <template v-slot:no-options>Nenhum produto encontrado.</template>
            </v-select>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div>
          <label> Dias em atraso:</label>
          <div class="input-group">
            <b-form-input v-model="form.diaAtrasoInicio.value" :state="form.diaAtrasoInicio.state" placeholder="De"
              type="number" />
            <b-form-input v-model="form.diaAtrasoFinal.value" :state="form.diaAtrasoFinal.state" placeholder="Até"
              type="number" />
          </div>
        </div>
      </div>
    </div>

    <div class="form-group row">
      <div class="w-100">
        <label style="font-size: medium; font-weight: 600;letter-spacing: 0.3px; color: #2e6e60; cursor: pointer"
          @click.prevent="showFilterSocialMedia === true ? showFilterSocialMedia = false : showFilterSocialMedia = true">
          <i v-if="showFilterSocialMedia" class="fas fa-caret-down"></i>
          <i v-else class="fas fa-caret-right"></i>
          Redes Sociais</label>
        <!-- <div style="display: block; position: relative;top: -15px; color: #787878"><small>Campanha em rede sociais</small></div>-->
      </div>
    </div>
    <div v-if="showFilterSocialMedia">
      <div class="form-group row">
        <div class="w-100">
          <label> UTM Campaign:</label>
          <div class="input-group">
            <b-form-input type="text" v-model="form.utmCampaign.value" :state="form.utmCampaign.state" />
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="w-100">
          <label> UTM Source:</label>
          <div class="input-group">
            <b-form-input type="text" v-model="form.utmSource.value" :state="form.utmSource.state" />
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="w-100">
          <label> UTM Medium:</label>
          <div class="input-group">
            <b-form-input type="text" v-model="form.utmMedium.value" :state="form.utmMedium.state" />
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="w-100">
          <label> UTM Content:</label>
          <div class="input-group">
            <b-form-input type="text" v-model="form.utmContent.value" :state="form.utmContent.state" />
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="w-100">
          <label> UTM Term:</label>
          <div class="input-group">
            <b-form-input type="text" v-model="form.utmTerm.value" :state="form.utmTerm.state" />
          </div>
        </div>
      </div>
    </div>

    <div class="form-group row">
      <div class="w-100 pt-2">
        <button type="button" class="btn rounded-4 btn-third w-100" v-on:click="onFilter">
          Filtrar
        </button>
      </div>
      <div class="w-100 pt-2">
        <button type="button" class="btn rounded-4 btn-default w-100" v-on:click="onClearFilters">
          Limpar Filtros
        </button>
      </div>
    </div>
    <!-- <div class="form-group row" style="margin-top: 600px;">&nbsp;</div> -->
  </div>
</template>

<script>
import CardSearch from './search.js'
export default CardSearch
</script>

<style lang="scss" scoped>

.disable-text-select {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.animated.fadeIn {
  padding-bottom: 2rem;
}

.animated.fadeIn::-webkit-scrollbar {
  display: none;
}

.form-group {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/board/search/search.vue